<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		
		<div class="">
			<el-form inline ref="form" :model="searchform">

				

					<el-form-item class="mb-0">
						 <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:150px;">
						   <el-option
								      v-for="item in searchform.searchOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>


					<el-form-item class="mb-0">
						 <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:100px" ></el-input>
					</el-form-item>
					<el-form-item  class="mb-0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px;">
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
            <el-button type="success" size="mini" icon="el-icon-document-delete" @click="exportExcel" :disabled = "disabled">{{$t('searchText.엑셀다운')}}</el-button> 
					</el-form-item>
			</el-form>
       
	
		</div>

    

    <div><span class="text-success ml-2">{{$t('msg.합계')}}{{formatMoney(total_money)}}</span></div>
	
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
      style="width: 100%"
      :row-class-name="tableRowClassName"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">
     
    <el-table-column  align="center" label="ID">

          <template v-if="loading==false"  slot-scope="scope">{{total-(currentPage-1)*40-scope.$index}}</template>
        </el-table-column>


            <el-table-column
        :label="$t('nav.아이디')" prop="mem_id" align="center">
          <template slot-scope="scope">
            
             <span style="cursor:pointer"  @click="openModel(scope.row.mem_id)">{{scope.row.mem_id}}({{scope.row.mem_name}})</span>
          </template>
      </el-table-column> 

     

    
          <el-table-column
        :label="$t('tableText.변동금액')"
         prop="money" align="center" >
         <template slot-scope="scope"><span class="bg-danger text-white mr-2 text-center" style="border-radius:100%;width:15px;height:15px;line-height:15px;display:inline-block;" v-if="scope.row.type==='4'||scope.row.type==='5'||scope.row.type==='6'||scope.row.type==='8' || scope.row.type==='9' || scope.row.type==='12'">P</span><span :class="scope.row.type==='1'||scope.row.type==='2'||scope.row.type==='3'||scope.row.type==='7' ? 'text-danger':'text-success'">{{ formatMoney(scope.row.money)}}</span></template>
      </el-table-column> 
       <el-table-column
        :label="$t('tableText.변동후머니')"
        prop="new_money" align="center" >
         <template slot-scope="scope" v-if="scope.row.type!='1' && scope.row.type!='7'">{{ formatMoney(scope.row.new_money)}}</template>
      </el-table-column> 
       <el-table-column
        
        :label="$t('tableText.변동후롤링')" prop="new_event" align="center" >
         <template slot-scope="scope" v-if="scope.row.type!='1' && scope.row.type!='7'">{{ formatMoney(scope.row.new_event)}}</template>
      </el-table-column> 

     

       <el-table-column
        
         :label="$t('tableText.메모')" prop="doc" align="center" >
        <template slot-scope="scope">{{scope.row.doc}}<el-button v-if="scope.row.idx=='0'" type="primary" size="mini" plain @click="logs(scope)">{{$t('msg.상세보기')}}</el-button></template>
      </el-table-column>

      <el-table-column
        
       :label="$t('tableText.아이피')" prop="ip" align="center">
      </el-table-column>

      <el-table-column
        
       :label="$t('tableText.시간')" prop="add_time" align="center">
      </el-table-column>
      

    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
        
         <el-dialog 
          :visible.sync="dialogModel"
          width="25%" style="height: 500px;overflow: hidden;" :close-on-click-modal ="false">

          <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
            
            <el-form-item :label="$t('nav.아이디')" class="mb-0">
              <el-input v-model="form.mem_id"  class="w-75"></el-input>
            </el-form-item>
            <el-form-item :label="$t('searchText.구분')" class="mb-0 " >
              <el-select :label="$t('status.선택')" v-model="gubun" class="w-75 typeIco">
                  <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('tableText.타입')" class="mb-0 ">
              <el-select placeholder="선택" v-model="io_type" class="w-75 typeIco">
                  <el-option
                  v-for="item in ioType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('tableText.금액')" class="mb-0">
              <el-input v-model="form.money" type="number"  class="w-75"></el-input>
            </el-form-item>

             <el-form-item :label="$t('tableText.메모')"class="mb-0">
              <el-input v-model="form.memo" type="text"  class="w-75"></el-input>
            </el-form-item>
         
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="dialogModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="cashSumbit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog> 
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
 import layerNew from '../../components/common/layer-new.vue';
 import * as XLSX from 'xlsx/xlsx.mjs';
    export default {
     components: {
      layer,layerNew
    },
    	data(){
    		return{
          disabled:false,
          total_emoney: '',
          total_money: '',
           total_pemoney: '',
          total_pmoney: '',
          gubun:'',
           form:{
            mem_id:'',
            money:'',
            memo:'',
          },
           io_type:'',
           ioType: [
               {
                label: this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
          options1: [{
               
                label:  this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }, {
                label:  this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
              }],

           level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")                 
            },
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
            bg:window.sessionStorage.getItem('bg'),
             userid:window.sessionStorage.getItem('userid'),
             aid:window.sessionStorage.getItem('admin_id'),
              power:window.sessionStorage.getItem('power'),
          formLoading:false,
          idDialogVisible: false,
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    				{
		        	label:this.$i18n.t("msg.아이디"),
		        	value:'mem_id'
		        },{
		        	label:this.$i18n.t("msg.닉네임"),
		        	value:'mem_name'
		        }
            

		        ],
		        
		        value:'',
		        


    			},
    			 pickerOptions: {
    			},
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
    
      
    			
		        
    		
    			total:0,
    			size:0,
    			loading: false,
    			tableData: [],
			    currentPage:1,   
          dialogModel:false,
    			}	
    			
    		},
    		created() {
    			this.getList();

		},
    	
    	methods:{
        openLayoutModel(e){
          this.dialogModel = true
          this.form.mem_id = e.row.mem_id
        },
           // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         tableRowClassName({row, rowIndex}) {
     
       if (rowIndex%2 === 1) {
        return 'odd-row';
       }
       else{
         return 'edd-row';
       }
    },
         openModel(id){
 let pix=window.screen.width;
           
                let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }
          if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: [width+'', '680px'],
             
             });
              return;
           }
           
            this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
        exportExcel() {
         let token=window.sessionStorage.getItem('user');
         this.disabled = true

         let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

          
           let urls=this.domain+'/admin/rolling_change?s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage+'&excel=1'
          

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{

               if(response.data.code!=200)
               {
                   this.$message.error(response.data.msg);
                   return;
               }


               let data = response.data.data

                this.total = response.data.total


               let wopts = {
                  bookType: 'xlsx',
                  bookSST: true,
                  type: 'binary'
                };
                let workBook = {
                  SheetNames: ['Sheet1'],
                  Sheets: {},
                  Props: {}
                };

                let table =data
                this.disabled = false

      
 
      workBook.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(table);

      XLSX.utils.sheet_add_aoa(workBook.Sheets['Sheet1'], [["Created "+new Date().toISOString()]], {origin:-1});
      XLSX.writeFile(workBook, "exchange.xlsb");

      this.$message.success(this.$i18n.t("msg.엑셀저장완료"))

                     
                     // this.tableData =data.data
                    
               
            }).catch((error) =>{

                this.disabled = false
              
               this.$message.error(error);
              this.loading = false
               
            })
      
     

 
  
    },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              
            
this.currentPage=1;

    			this.getList();
    			
             

    		},
         cashSumbit(){
          let token=window.sessionStorage.getItem('user');
           this.loading = true
              this.$axios({
                    method:'post',
                    url:this.domain+'/admin/cash_event_up',
                    data:{
                      mem_id:this.form.mem_id,
                      money:this.form.money,
                      memo:this.form.memo,
                      gubun:this.gubun,
                      io_type:this.io_type
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                
                     this.loading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
            

                     this.form.mem_id=''
                     this.form.money=''
                     this.form.memo=''
                       this.dialogModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })
        },
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     
    		getList(){

    		   
              

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/rolling_change?s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;
    			
    			// if(bm!='')
    			// {
       //            urls=urls+'&search=service_no%3A'+bm+'%3Bphone%3A'+bm+'%3Btoken%3A'+bm+'%3Bmac%3A'+bm;
    			// }
             
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data.data)
                     this.tableData =response.data.data.data
                     this.total = response.data.data.total
                     this.currentPage = response.data.data.current_page
                     this.size =response.data.data.per_page
                     this.total_emoney = response.data.total_emoney
                     this.total_money = response.data.total_money

                     this.total_pemoney = response.data.total_pemoney
                     this.total_pmoney = response.data.total_pmoney


                     this.loading =false
               
            }).catch((error) =>{
            	
                 this.$message.error(error);
              this.loading = false
               
            })
    		},
    		
    		
    
    	
    		
    	}
  }
</script>

 <style scoped>
 

/deep/ .el-form-item {
	margin-bottom:10px;
}
/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 /deep/.typeIco .el-input__icon{
  line-height: 30px;
 }

</style>


// WEBPACK FOOTER //
// src/views/rolling_c/list.vue